export default __webpack_public_path__ + "static/media/circle_exclamation.1d5d2360.svg";